var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 14.042c0 3.16 1.811 4.959 3.838 4.959 1.855 0 3.407-1.75 3.407-3.84 0-2.091-1.294-3.5-2.932-3.5-.345 0-.69.048-.863.145.388-1.75 1.984-3.792 3.364-4.618L8.442 5.001C5.768 7.139 4 10.396 4 14.042m8.798 0c0 3.16 1.811 4.959 3.838 4.959C18.491 19 20 17.25 20 15.16c0-2.091-1.25-3.5-2.89-3.5-.345 0-.733.048-.862.145.345-1.75 1.984-3.792 3.364-4.618L17.24 5.001c-2.674 2.138-4.442 5.395-4.442 9.041"
})));
export default SvgGemQuote;